
<template>
	<div id="lodging-all" :class="{ 'filter-layer-active': showFilterSidebar && !isPhone }">
		<!-- Mobile Map Modal (unchanged) -->
		<div v-if="showMap && isPhone" class="full-page-modal">
			<div class="modal-header">
				<button class="close-btn" @click="toggleMap">×</button>
			</div>
			<div id="map-test">
				<Maptest
				:markers="markers"
				:lodgings="lodgingsCounter === 0 ? allLodgings : previous_lodging"
				@markerSelected="selectCardMap"
				:selectCardMap="selectCardMap"
				:selectCard="selectCard"
				@close="toggleMap"
				/>
			</div>
		</div>

		<div class="lodge-page-main">

			<BannerPage
				:title="getGroupTitle || pageTitle"
				:page-title="pageTitle"
				:subtitle="getGroupSubTitle || pageSubtitle"
				:description="formatLodgings()"
				:banner-image="bannerImage || getBannerImage"
			/>
			
			<div class="container-index custom-index mt-page">
				<div id="search-bannerr" ref="searchBar">
					<SearchLodging
						v-if="!isPhone"
						:activeFilters="changedFilters"
						:isPhone="isPhone"
						:lodgingsCounter="lodgingsCounter"
						:showFiltersInSticky="true"
						@updateFilteredLodgings="updateFilteredLodgings"
						@updateSearch="search = $event"
						@selectDates="updateDates"
						@adultsNum="setAdults"
						@childsNum="setChilds"
						@toggleFilterSidebar="toggleFilterSidebar"
						@toggleMobileFilter="showFilt = !showFilt"
						@sortByNote="sortByNote"
						@sortByTarif="sortByTarif"
						@displayMap="displayMap"
						@regionSelected="selectedRegionName = $event"
						@fetchAvailabilityData="handleFetchAvailabilityData"
						@close="false">
					</SearchLodging>
				</div>

				<!-- Filter and Sort Controls -->
				<LodgingFiltersButtons
					:isPhone="isPhone"
					:lodgingsCounter="lodgingsCounter"
					:showMobileStickyFilters="showMobileStickyFilters"
					@toggleFilterSidebar="toggleFilterSidebar"
					@toggleMobileFilter="showFilt = !showFilt"
					@sortByNote="sortByNote"
					@sortByTarif="sortByTarif"
					@displayMap="displayMap"
					class="mt-4"
				/>

				<!-- Main Content Layout -->
				<div class="main-content-wrapper">
					<!-- Left Filter Sidebar (Desktop) -->
					<div class="filter-sidebar" :class="{ 'filter-sidebar-open': showFilterSidebar }" v-if="!isPhone">
						<div class="filter-sidebar-content">
							<div class="filter-sidebar-header">
								<h3 class="raleway-bold-h4">Filtres</h3>
								<button class="close-filter-btn" @click="toggleFilterSidebar">×</button>
							</div>
							<Filterlodgings
								:servicesMount="servicesMount"
								:filterCounts="filterCounts"
								@checked="setData"
								@switch="setData"
								@changedBudget="setData"
								@changedAdults="setData"
								@changedChilds="setData"
							/>
						</div>
					</div>

					<!-- Filter Sidebar Overlay -->
					<div class="filter-sidebar-overlay" v-if="showFilterSidebar && !isPhone" @click="toggleFilterSidebar"></div>

					<!-- Mobile Filter (unchanged) -->
					<MobileFilterlodgings
						v-if="isPhone && showFilt"
						:servicesMount="servicesMount"
						:filterCounts="filterCounts"
						@checked="setData"
						@switch="setData"
						@changedBudget="setData"
						@changedAdults="setData"
						@changedChilds="setData"
						@close="showFilt = false"
					/>

					<div class="lodgings-count-display mb-4">
						<p class="raleway-semi-p16 mb-0">{{ formatLodgingsCount() }}</p>
					</div>
					<!-- Main Content with Map Layout -->
					<div class="content-with-map-wrapper">
						<!-- Content Area -->
						<div class="content-area" :class="{ 'with-map': !isPhone }">
							<!-- Lodgings Grid -->
							<div class="lodgings-grid" :class="{ 'loading': isLoadingLodgings }">
								<!-- Loading Skeletons -->
								<div v-if="isLoadingLodgings" class="skeleton-container">
									<LodgingSkeleton v-for="n in 20" :key="'skeleton-' + n" />
								</div>
								<!-- Lodgings Count Display -->

								<!-- Actual Lodgings -->
								<div v-else-if="!selectedMarker" class="lodgings-list">
								
									<!-- All lodgings in consistent 2-column grid -->
									<div class="lodgings-grid-container">
										<div
											v-for="(lodging, index) in filteredLodgings"
											:key="`lodging-${lodging.id}-${index}`"
											class="lodging-item"
										>
											<CardProductbigV2
												:wishlistLodgings="wishlistLodgings"
												:lodging="lodging"
												:user="isUserConnected()"
												:lodgingList="filteredLodgings"
												:destination="lodging.destination"
												:showFromLodgingsPage="true"
												:to="to"
												:from="from"
												:data-marker="index"
												:data-lodging="lodging.id"
												:availabilityData="roomsCountAvailability[lodging.id]"
												@hideBigMap="hideBigMap"
												@hideSmallMap="hideSmallMap"
												@cardHover="handleCardHover"
												@focusOnMap="handleFocusOnMap"
												@wishlistUpdated="handleWishlistUpdated"
												:showMapCard="showMapCard"
											/>

											<!-- Mobile Banners -->
											<div v-if="index === 6 && isPhone" :key="'banner-after-7'" style="margin: 20px 0;" class="hortense-banner-wrapper">
												<div style="position: relative;">
													<img
													src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-proposition-valeur-mobile-privilege+.gif"
													alt="Expérience Hortense Banner"
													style="width: 100%; height: auto; display: block;"
													class="hortense-banner-img"
													/>
													<button @click="showModal = true" class="hortense-cta-button-on-image-two">Je crée mon compte</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- Selected Marker View -->
								<div v-else>
									<!-- Cardmap component for selected marker -->
								</div>
							</div>

							<!-- No Results -->
							<div v-if="lodgingsCounter === 0" class="no-lodging text-center raleway-reg-p15">
								<p class="merriweather-reg-24">Destination introuvable… pour le moment</p>
								<p class="raleway-reg-p15 pb-3"> Aucun lieu n’est encore disponible dans cette destination. Mais dites-nous ce que vous recherchez... Hortense se fera un plaisir de dénicher pour vous l’hébergement de charme parfait, où que vous souhaitiez aller.</p>
								<a :href="'/voyage-sur-mesure/'" class="hortense-btn-primary" :class="{'cta': !isPhone}">Contactez-nous</a>
							</div>

							<!-- Popular Destinations -->
							<div class="mt-5 mb-5" v-if="lodgingsCounter === 0">
								<p class="merriweather-reg-24 text-center">Nos destinations en vogue</p>
								<ImagesCards
									:images_data="destinationImages"
									:config="{
										gridCols: isPhone ? 1 : 2,
										gap: '40px',
										imageWidth: '100%',
										imageHeight: '309px'
									}"
								/>
							</div>
						</div>

						<!-- Right Map Panel (Desktop Only) -->
						<div v-if="!isPhone" class="map-panel">
							<div class="map-container" data-aos="fade-left" data-aos-duration="500">
								<Maptest
									ref="mapTest"
									:markers="markers"
									:lodgings="lodgingsCounter === 0 ? allLodgings : previous_lodging"
									:hoveredLodgingId="hoveredLodgingId"
									@markerSelected="selectCardMap"
									:selectCardMap="selectCardMap"
									:selectCard="selectCard"
									@close="() => {}"
								/>
							</div>
						</div>
					</div>
				</div>
				
				<!-- Pagination - Moved outside content area to remain always visible -->
				<nav v-if="lodgingsCounter !== 0 && !selectedMarker" class="pagination-container mt-4">
					<ul class="pagination">
						<li class="page-item" @click="scrollToTop">
							<button
								v-for="pageNumber in pages"
								:class="page_number_count === pageNumber ? 'active-item' : ''"
								type="button"
								class="page-link"
								@click="fetchLodgings(pageNumber)">
								{{pageNumber}}
							</button>
						</li>
					</ul>
				</nav>

				<!-- Promotional Banners -->
				<div v-if="!isPhone" :key="'banner-after-7'" class="hortense-banner-wrapper row" id="promotion-lodge-banner" style="margin: 20px 0;">
					<div style="position: relative;">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-proposition-valeur-desktop--privilege-banner-1.gif" alt="Expérience Hortense Banner" class="hortense-banner-img" style="width: 100%;" />
						<button @click="showModal = true" class="hortense-cta-button-desktop">Je crée mon compte</button>
					</div>
				</div>

				<!-- Search Content -->
				<div class="search-page-html-wrapper mt-5" v-if="searchContent">
					<div
						ref="contentBlock"
						:class="['scoped-html', { collapsed: !isExpanded }]"
						v-html="scopedContent"
						></div>

						<p v-if="contentExceedsLimit" class="expand-toggle mt-3" @click="isExpanded = !isExpanded">
						{{ isExpanded ? 'Afficher moins' : 'Afficher plus' }}
						</p>
					</div>
			</div>
		</div>
		
		<!-- Modal -->
		<Modalsignup v-if="showModal" @close="setUser"></Modalsignup>
	</div>
</template>

<script>
	import _ from 'lodash';
	import CardProductbigV2 from '../../components/cards/CardProductbigV2.vue';
	import Filterlodgings from '../../pages/destinations/Filterlodgings.vue';
	import Cardmap from '../../components/cards/Cardmap.vue';
	import Maptest from '../../components/Maptest.vue';
	import fetcher from '../../packs/shared/api.js';
	import Modalsignup from '../../components/modals/Modalsignup.vue';
	import MobileFilterlodgings from '../destinations/MobileFilterlodgings.vue';
	import ImagesCards from "../../components/shared/ImagesCards.vue";
	import BannerPage from "../../components/BannerPage.vue";
	import axios from 'axios';
	import ScopedHtmlRenderer from './ScopedHtmlRenderer.vue';
	import AOS from 'aos';
	import SearchLodging from "../../components/btns/Searchlodging.vue";
	import LodgingSkeleton from './LodgingSkeleton.vue';
	import LodgingFiltersButtons from '../../components/LodgingFiltersButtons.vue';
import { param } from 'jquery';
	const MONTH_RE = /\/offres-exclusives-(janvier|fevrier|mars|avril|mai|juin|juillet|aout|septembre|octobre|novembre|decembre)/i;
	const MONTH_LABELS = {
	janvier: 'Janvier', fevrier: 'Février', mars: 'Mars', avril: 'Avril',
	mai: 'Mai', juin: 'Juin', juillet: 'Juillet', aout: 'Août',
	septembre: 'Septembre', octobre: 'Octobre', novembre: 'Novembre', decembre: 'Décembre'
	};

	const TITLES_MAP = {
	"/reservation-hotel": "Notre Sélection",
	"/notre-selection-saint-valentin": "Notre Sélection",
	"/hotel-de-charme": "Nos Hôtels de charme",
	"/villa-de-charme": "Nos Villas de charme",
	"/chambres-dhotes-de-charme": "Nos Chambres d’hôtes de charme",
	"/logement-insolite-de-luxe": "Nos Logements insolites de luxe",
	"/appartement-de-vacances": "Nos Appartements de vacances",
	"/les-nouveautes-hortense": "Nos Nouveautés",
	"/maisons-de-charme": "Nos Maisons de charme",
	"/chalet": "Nos Chalets",
	"/ecolodge": "Nos Écolodges",
	"/hotel-luxe": "Nos Hôtels de luxe",
	"/hotel-5-etoiles": "Nos Hôtels 5 étoiles",
	"/hotel-4-etoiles": "Nos Hôtels 4 étoiles",
	"/hotel-3-etoiles": "Nos Hôtels 3 étoiles",
	"/hotel-bord-de-mer": "Nos Hôtels en bord de mer",
	"/hotel-piscine": "Nos Hôtels avec piscine",
	"/hotel-romantique": "Nos Hôtels romantiques",
	"/hotel-gastronomique": "Nos Hôtels gastronomiques",
	"/hotel-chateaux": "Nos Hôtels-châteaux",
	"/villa-de-luxe-piscine": "Nos Villas de luxe avec piscine",
	"/location-jacuzzi": "Nos Locations avec jacuzzi",
	"/location-piscine": "Nos Locations avec piscine",
	"/chambre-dhotes-piscine": "Nos Chambres d’hôtes avec piscine",
	"/maisons-dhotes-piscine": "Nos Maisons d’hôtes avec piscine",
	"/vacances-ete": "Vacances d’été : Votre évasion éco-chic sous le soleil",
	"/vacances-printemps": "Vacances de printemps : Votre évasion éco-chic au réveil de la nature",
	"/vacances-noel": "Vacances de Noël : Votre évasion éco-chic au cœur des fêtes",
	"/vacances-hiver": "Vacances d’hiver : Votre évasion éco-chic au charme hivernal",
	"/vacances-toussaint": "Vacances de la Toussaint : Votre évasion éco-chic aux couleurs de l’automne",
	"/offres-exclusives":        "Nos offres exclusives pour votre prochaine évasion éco-chic",
	"/offres-long-week-end":     "Nos offres long week-end pour votre prochaine évasion éco-chic",
	"/offres-long-sejour":       "Nos offres long séjour pour votre prochaine évasion éco-chic",
	"/offres-exclusives-janvier":   "Offres Exclusives Janvier",
	"/offres-exclusives-fevrier":   "Offres Exclusives Février",
	"/offres-exclusives-mars":      "Offres Exclusives Mars",
	"/offres-exclusives-avril":     "Offres Exclusives Avril",
	"/offres-exclusives-mai":       "Offres Exclusives Mai",
	"/offres-exclusives-juin":      "Offres Exclusives Juin",
	"/offres-exclusives-juillet":   "Offres Exclusives Juillet",
	"/offres-exclusives-aout":      "Offres Exclusives Août",
	"/offres-exclusives-septembre": "Offres Exclusives Septembre",
	"/offres-exclusives-octobre":   "Offres Exclusives Octobre",
	"/offres-exclusives-novembre":  "Offres Exclusives Novembre",
	"/hebergements-moins-2h-paris": "Notre sélection à moins de 2h de Paris",
	"/hebergements-moins-2h-lyon": "Notre sélection à moins de 2h de Lyon",
	"/hebergements-moins-2h-bordeaux": "Notre sélection à moins de 2h de Bordeaux",
	"/offres-exclusives-decembre":  "Offres Exclusives Décembre",
  };
  
  const SUBTITLES_MAP = {
	'/reservation-hotel': "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens",
	"/notre-selection-saint-valentin": "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens",
	'/hotel-de-charme': "Séjournez dans les plus beaux hôtels de charme avec Hortense !",
	'/villa-de-charme': "Pour se sentir comme à la maison !",
	'/chambres-dhotes-de-charme': "Immergez-vous dans une atmosphère conviviale et accueillante avec Hortense !",
	'/logement-insolite-de-luxe': "Pour vivre une expérience unique et hors du commun !",
	'/appartement-de-vacances': "Découvrez des appartements d'exception pour des vacances mémorables",
	"/maisons-de-charme": "L’élégance et l’authenticité au rendez-vous",
	"/chalet": "L’alliance parfaite entre nature, confort et éco-responsabilité",
	"/ecolodge": "L’alliance parfaite entre nature et élégance",
	"/hotel-luxe": "Élégance, confort et service d'exception pour un séjour inoubliable",
	"/hotel-5-etoiles": "Une expérience inégalée de prestige",
	"/hotel-4-etoiles": "Confort et élégance pour un séjour parfait",
	"/hotel-3-etoiles": "Confort et qualité pour un séjour agréable",
	"/hotel-bord-de-mer": "Séjournez face à l’horizon",
	"/hotel-piscine": "Luxe et rafraîchissement garanti",
	"/hotel-romantique": "Une parenthèse enchantée à deux",
	"/hotel-gastronomique": "Un voyage des saveurs et des émotions",
	"/hotel-chateaux": "Une immersion dans l’histoire et le prestige",
	"/villa-de-luxe-piscine": "Un séjour exclusif et raffiné",
	"/location-jacuzzi": "Une parenthèse de relaxation absolue",
	"/location-piscine": "Une oasis de fraîcheur et de sérénité",
	"/chambre-dhotes-piscine": "Charme et détente au rendez-vous",
	"/maisons-dhotes-piscine": "Un havre de paix et de bien-être",
	"/vacances-ete": "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens",
	"/vacances-printemps": "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens",
	"/vacances-noel": "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens",
	"/vacances-hiver": "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens",
	"/vacances-toussaint": "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens",
	"/offres-exclusives":        "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens.",
	"/offres-long-week-end":     "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens.",
	"/offres-long-sejour":       "Des lieux d’exception. Des privilèges exclusifs. Des séjours qui ont du sens.",
	"/offres-exclusives-janvier":   "En Janvier, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-fevrier":   "En Février, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-mars":      "En Mars, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-avril":     "En Avril, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-mai":       "En Mai, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-juin":      "En Juin, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-juillet":   "En Juillet, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-aout":      "En Août, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-septembre": "En Septembre, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-octobre":   "En Octobre, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/offres-exclusives-novembre":  "En Novembre, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
	"/hebergements-moins-2h-paris": "Des lieux d'exception. Des privilèges exclusifs. Des séjours qui ont du sens.",
	"/hebergements-moins-2h-lyon": "Des lieux d'exception. Des privilèges exclusifs. Des séjours qui ont du sens.",
	"/hebergements-moins-2h-bordeaux": "Des lieux d'exception. Des privilèges exclusifs. Des séjours qui ont du sens.",
	"/offres-exclusives-decembre":  "En Décembre, profitez des offres exclusives Hortense : réductions sur vos longs séjours et week-ends pour une évasion éco-chic alliant nature, confort et raffinement.",
  };
  
  const BANNER_IMAGE_MAP = {
	"Violaine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+oenologique.webp",
	"Domitille": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/chambre+d_ho%CC%82tes.webp",
	"Valentine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+amoureux.webp",
	"Solveig": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/location+maison+de+charme.webp",
	"Sissy": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/Se%CC%81jour+cha%CC%82teau.webp",
	"Caroline": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/City-break.webp",
	"Iseult": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+romantique.webp",
	"Amandine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+gastronomique.webp",
	"Yoko": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+soleil.webp",
	"Eden": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+spa.webp",
	"Montaine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+a%CC%80+la+montagne.webp",
	"Philomène": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+en+famille.webp",
	"Vénus": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/voyage+de+noce.webp",
	"Lana": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+piscine.webp",
	"Léonie": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/voyage+d_affaire.webp",
	"Océane": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+a%CC%80+la+mer.webp",
	"Garance": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+a%CC%80+la+campagne.webp",
	"Séraphine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/e%CC%81ve%CC%81nement+e%CC%81co-responsable.webp",
	"Ondine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+au+bord+de+l_eau.webp",
	"Iris": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+nature.webp",
	"France": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/France.webp",
	"Auvergne-rhône-alpes": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Auvergne-Rhone-Alpes.webp",
	"Bourgogne-franche-comté": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Bourgogne-Franche-Comte%CC%81.webp",
	"Centre-val de loire": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Centre-Val-de-Loire.webp",
	"Ile-de-france": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Ile-de-France.webp",
	"Pays de la loire": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Pays-de-la-Loire.webp",
	"Provence-alpes-côte d’azur": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Provence-Alpes-Co%CC%82te-d%E2%80%99Azur.webp",
	"Corse": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Corse.webp",
	"Occitanie": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Occitanie.webp",
	"Nouvelle-aquitaine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Nouvelle-Aquitaine.webp",
	"Bretagne": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Bretagne.webp",
	"Normandie": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Normandie.webp",
	"Grand est": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Grand+Est.webp",
	"Hauts-de-france": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Destination/Hauts-de-France.webp",
	"Océan indien": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Ocean+indien.webp",
	"Maroc": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Maroc.webp",
	"Tunisie": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Tunisie.webp",
	"Europe": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Europe.webp",
	"Caraïbes": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Carai%CC%88bes.webp",
	"Asie": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Asie.webp",
	"Philippines": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Philippines.webp",
	"Afrique": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Afrique.webp",
	"Martinique": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Autres+destinations/Martinique.webp",
	"Saint-barthélemy": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Saint-Barthe%CC%81le%CC%81my.webp",
	"Les maldives": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Les+Maldives.webp",
	"Ile maurice": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Ile+Maurice.webp",
	"Guadeloupe": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Guadeloupe.webp",
	"La réunion": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/La+Re%CC%81union.webp",
	"Madagascar":  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Madagascar.webp",
	"Mayotte": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/La+Mayotte.webp",
	"Les seychelles": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Les+Seychelles.webp",
	"Guyane": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Guyane.webp",
	"Saint-martin": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Saint-Martin.webp",
	"St vincent-et-les-grenadines": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/St+Vincent-et-les-Grenadines.webp",
	"Îles turks-et-caïques": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/I%CC%82les+Turks-et-Cai%CC%88ques.webp",
	"Sainte-lucie": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Sainte-Lucie.webp",
	"Tanzanie": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/autres+destinations/Tanzanie.webp",
	"Cupidon": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/week-end+romantique.webp",
	"Écrin de verdure": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+nature.webp",
	"Culture": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+culturel.webp",
	"Atypique": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+insolite.webp",
	"Foodies": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+gourmand.webp",
	"Relaxation": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+spa.webp",
	"Bord de mer": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/week-end-mer.webp",
	"Sommets": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+%C3%A0+la+montagne.webp",
	"Bien-être": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+thalasso.webp",
	"Épicuriens": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+oenologique.webp",
	"Sérénité": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+d%C3%A9tente.webp",
	"Aphrodite": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+amoureux.webp",
	"City break": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+city+break.webp",
	"Zénitude": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Week-ends/Week-end+bien-%C3%AAtre.webp",
	"Nos Hôtels de charme": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+de+charme.webp",
	"Nos Chambres d’hôtes de charme": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Chambre+d%E2%80%99ho%CC%82tes+de+charme.webp",
	"Nos Villas de charme": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Villas+de+charme.webp",
	"Nos Maisons de charme": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Appartement+de+vacances.webp",
	"Nos Logements insolites de luxe": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Nos+logements+insolites+de+luxe.webp",
	"Nos Écolodges": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/E%CC%81colodge.webp",
	"Nos Hôtels de luxe": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+de+luxe.webp",
	"Nos Hôtels 5 étoiles": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+5+e%CC%81toiles.webp",
	"Nos Hôtels 4 étoiles": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+4+e%CC%81toiles.webp",
	"Nos Hôtels 3 étoiles": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+4+e%CC%81toiles.webp",
	"Nos Hôtels en bord de mer": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+bord+de+mer.webp",
	"Nos Hôtels avec piscine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+piscine.webp",
	"Nos Hôtels romantiques": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+romantique.webp",
	"Nos Hôtels gastronomiques": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/ho%CC%82tel+gastronomique.webp",
	"Nos Hôtels-châteaux": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Ho%CC%82tel+cha%CC%82teaux.webp",
	"Nos Villas de luxe avec piscine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Villa+de+luxe+piscine.webp",
	"Nos Locations avec jacuzzi": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Location+jacuzzi.webp",
	"Nos Locations avec piscine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Location+piscine.webp",
	"Nos Chambres d’hôtes avec piscine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Chambre+d_ho%CC%82tes+piscine.webp",
	"Nos Maisons d’hôtes avec piscine": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Maisons+d_ho%CC%82tes+piscine.webp",
	"Nos Nouveautés": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/PAGE+-+Nos+nouveaut%C3%A9s.jpg",
	"Nos Hébergements": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+h%C3%B4tel.webp",
	"Nos Chalets": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+%2B+Divers/Chalet.webp",
	"Tribu": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Collections-20250427T103139Z-001/Collections/se%CC%81jour+en+famille.webp",
	"Vacances d’été : Votre évasion éco-chic sous le soleil":
    "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-ete.webp",
	"Vacances de printemps : Votre évasion éco-chic au réveil de la nature":
		"https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-printemps.webp",
	"Vacances de Noël : Votre évasion éco-chic au cœur des fêtes":
		"https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-noel.webp",
	"Vacances d’hiver : Votre évasion éco-chic au charme hivernal":
		"https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-hiver.webp",
	"Vacances de la Toussaint : Votre évasion éco-chic aux couleurs de l’automne":
		"https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-toussaint.webp",
		"Offres exclusives Janvier":  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-janvier.webp",
		"Offres exclusives Février":  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-fevrier.webp",
		"Offres exclusives Mars":     "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-mars.webp",
		"Offres exclusives Avril":    "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-avril.webp",
		"Offres exclusives Mai":      "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-mai.webp",
		"Offres exclusives Juin":     "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-juin.webp",
		"Offres exclusives Juillet":  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-juillet.webp",
		"Offres exclusives Août":     "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-aout.webp",
		"Offres exclusives Septembre":"https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-septembre.webp",
		"Offres exclusives Octobre":  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-octobre.webp",
		"Offres exclusives Novembre": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-novembre.webp",
		"Offres exclusives Décembre": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive-decembre.webp",
	"Notre sélection à moins de 2h de Paris": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hebergements+-+2h/paris.webp",
	"Notre sélection à moins de 2h de Lyon": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hebergements+-+2h/lyon.webp",
	"Notre sélection à moins de 2h de Bordeaux": "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Hebergements+-+2h/bordeaux.webp",
		"Nos offres exclusives pour votre prochaine évasion éco-chic":     "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-exclusive.webp",
		"Nos offres long week-end pour votre prochaine évasion éco-chic":  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-long-week-end.webp",
		"Nos offres long séjour pour votre prochaine évasion éco-chic":    "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/offre-long-sejour.webp",
  };

	export default {
		name: 'lodgings-v2',
		components: {
			SearchLodging,
			CardProductbigV2,
			Filterlodgings,
			Maptest,
			Cardmap,
			Modalsignup,
			MobileFilterlodgings,
			ImagesCards,
			BannerPage,
			ScopedHtmlRenderer,
			LodgingSkeleton,
			LodgingFiltersButtons
		},
		props: ['pagedNumber','lodgings', 'user', 'search-type', 'page-description', 'page-subtitle', 'page-name', 'page-title', 'services', 'serviceEntiers', 'styles', 'desires', 'type', 'all-filtered-lodgings', 'filterCounts', 'lodgings-count-before-filtering', 'pageTitle','pageSubtitle','pageDescription','bannerImage'],
		data() {
			return {
				monthKey: null,
				// New v2 data properties
				showFilterSidebar: false,
				isLoadingLodgings: false,
				hoveredLodgingId: null,
				mapStickyActive: false,
				scrollHandler: null,
				mobileScrollHandler: null,
				showMobileStickyFilters: true,
				// Cache initial positions to prevent layout shift feedback loops
				cachedPositions: {
					searchBannerBottom: null,
					promotionBannerTop: null,
					initialized: false
				},
				cachedPositionsTimeout: null,
				roomsCountAvailability: {},
				
				// Existing properties (unchanged)
				isExpanded: false,
				searchContent: null,
				contentExceedsLimit: false,
				showModal: false,
				previous_lodging: this.parseInitialFilteredLodgings(),
				paged_number: this.pagedNumber,
				pagedLodgings: [],
				showMapCard: false,
				wishlistLodgings: null,
				page: 1,
				page_number_count: 1,
				perPage: 20,
				pages: [],
				changedFilters: {},
				lodgingsList: null,
				filteredLodgings: this.lodgings,
				showMap: false,
				selectedMarker: false,
				selectedLodging: null,
				showFilt: false,
				selectedCard: null,
				current: 1,
				asc: true,
				tarifSort: true,
				allValues: {
					score: [null, '4', '5', '6', '7', '8', '9', '10'],
					standing: [null, '0', '1', '2', '3', '4', '5'],
					type: [null, 'Hotel', 'Guestroom', 'Maison et Villa', 'Appartment', 'Lodge', 'Chalet'],
					budget: [0, 5000],
					childs: 0,
					adults: 2,
					breakfast_include: false,
					half_pension: false,
					full_pension: false,
					all_inclusive: false,
					animal: false,
					business: false,
					freeCancel: false,
					services: [],
					styles: [],
					desires: [],
					eq_services: [],
					eq_services_entiers: [],
					delice: false,
					escapade: false,
					evasion: false,
					plaisirs: false
				},
				koediaFrom: null,
				koediaTo: null,
				from: null,
				to: null,
				base: null,
				activeFilters: {
					score: [null, '4', '5', '6', '7', '8', '9', '10'],
					standing: [null, '0', '1', '2', '3', '4', '5'],
					type: [null, 'Hotel', 'Guestroom', 'Maison et Villa', 'Appartment', 'Lodge', 'Chalet'],
					budget: [0, 2000],
					childs: 0,
					adults: 2,
					breakfast_include: false,
					half_pension: false,
					full_pension: false,
					all_inclusive: false,
					animal: false,
					business: false,
					freeCancel: false,
					services: [],
					styles: [],
					desires: [],
					eq_services: [],
					eq_services_entiers: [],
					delice: false,
					escapade: false,
					evasion: false,
					plaisirs: false
				},
				servicesMount: [],
				destinationImages: [
					{ image_url: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/destination+-+page+sans+resultat/bourgogne.webp',
						text_content: '<div class="d-flex flex-column"><p class="raleway-bold-p15 mb-1 text-uppercase">Bourgogne</p><p class="raleway-bold-p12">FRANCE</p></div>',
						link: '/destination/bourgogne-franche-comte'
					},
					{ image_url: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/destination+-+page+sans+resultat/centre-de-Loire.webp',
						text_content: '<div class="d-flex flex-column"><p class="raleway-bold-p15 mb-1 text-uppercase">Centre val de loire</p><p class="raleway-bold-p12">FRANCE</p></div>',
						link: '/destination/centre-val-de-loire' 
					},
					{ image_url: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/destination+-+page+sans+resultat/Corse.webp',
						text_content: '<div class="d-flex flex-column"><p class="raleway-bold-p15 mb-1">CORSE</p><p class="raleway-bold-p12">FRANCE</p></div>',
						link: '/destination/corse'
					},
					{ image_url: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/destination+-+page+sans+resultat/Normandie.webp',
						text_content: '<div class="d-flex flex-column"><p class="raleway-bold-p15 mb-1">NORMANDIE</p><p class="raleway-bold-p12">FRANCE</p></div>',
						link: '/destination/normandie'
					},
					{ image_url: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/destination+-+page+sans+resultat/Occitanie.webp',
						text_content: '<div class="d-flex flex-column"><p class="raleway-bold-p15 mb-1">OCCITANIE</p><p class="raleway-bold-p12">FRANCE</p></div>',
						link: '/destination/occitanie'
					},
					{ image_url: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/destination+-+page+sans+resultat/Pays-de-Loire.webp',
						text_content: '<div class="d-flex flex-column"><p class="raleway-bold-p15 mb-1 text-uppercase">Pays de la loire</p><p class="raleway-bold-p12">FRANCE</p></div>',
						link: '/destination/pays-de-la-loire'
					},
				],
				cancelTokenSource: null,
				search: '',
				allLodgings: [],
				filterCounts: {},
				selectedRegionName: null
			};
		},
		watch: {
			// Existing watchers (unchanged)
			allValues: {
				deep: true,
				handler(val) {
					this.activeFilters = Object.assign({}, val);
				},
			},
			lodgings: {
				immediate: true,
				handler(val) {
					this.lodgingsList = val.map((el) => {
						if (typeof el === 'string') {
							try {
								return JSON.parse(el);
							} catch (e) {
								return el;
							}
						}
						return el;
					});
					this.filteredLodgings = this.lodgingsList;
					this.setPages();
				},
			},
			filteredLodgings() {
					this.setPages();
			},
			servicesMount: {
				deep: true,
				handler(val) {
					if(val) {
						if (!val.length) return;
						this.allValues.services = val.map((el) => el.id);
					}
				},
			},
		},
		computed: {
			isPhone() {
				if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
					return true;
				}else{
					return false;
				}
			},
			scopedContent() {
				if (!this.searchContent || !this.searchContent.content) return '';
				const stripped = this.searchContent.content.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
				return `<div class="scoped-html-inner">${stripped}</div>`;
			},
			markers() {
				// If no lodgings found, show all lodgings on map
				const lodgings = this.lodgingsCounter === 0 ? this.allLodgings : this.previous_lodging;
				return (lodgings || [])
				.filter(el => el.latitude && el.longitude)
				.map(el => [el.longitude, el.latitude, el.id, el.lowest_price]);
			},
			getGroupTitle() {
				const url = window.location.pathname;
				const monthKey = this.monthlyMatch(url);
				if (monthKey) {
				return `Offres exclusives ${MONTH_LABELS[monthKey]}`;
				}
				
				// Check if URL is a destination with lodging type (e.g., /destination/bretagne/maisons-de-charme)
				const destinationMatch = url.match(/^\/destination\/([^\/]+)\/(.+)$/);
				if (destinationMatch) {
					const destination = destinationMatch[1];
					const lodgingType = destinationMatch[2];
					// Return destination name with lodging type
					const capitalizedDest = destination.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
					const lodgingTypeKey = '/' + lodgingType;
					const lodgingTypeTitle = TITLES_MAP[lodgingTypeKey];
					if (lodgingTypeTitle) {
						return `${capitalizedDest}`;
					}
					return capitalizedDest;
				}
				
				for (const key in TITLES_MAP) {
				if (url.includes(key)) return TITLES_MAP[key];
				}
				return this.pageName;
			},
			getGroupSubTitle() {
				const url = window.location.pathname;
				const monthKey = this.monthlyMatch(url);
				if (monthKey) {
				return `Les meilleures offres du mois de ${MONTH_LABELS[monthKey]} pour une évasion éco-chic`;
				}
				
				// Check if URL is a destination with lodging type (e.g., /destination/bretagne/maisons-de-charme)
				const destinationMatch = url.match(/^\/destination\/([^\/]+)\/(.+)$/);
				if (destinationMatch) {
					const lodgingType = destinationMatch[2];
					const lodgingTypeKey = '/' + lodgingType;
					const lodgingTypeSubtitle = SUBTITLES_MAP[lodgingTypeKey];
					if (lodgingTypeSubtitle) {
						return lodgingTypeSubtitle;
					}
					return this.pageSubtitle;
				}
				
				for (const key in SUBTITLES_MAP) {
				if (url.includes(key)) return SUBTITLES_MAP[key];
				}
				return this.pageSubtitle;
			},
			getBannerImage() {
				// Check if URL is a destination with lodging type (e.g., /destination/bretagne/maisons-de-charme)
				const url = window.location.pathname;
				const destinationMatch = url.match(/^\/destination\/([^\/]+)\/(.+)$/);
				if (destinationMatch) {
					const destination = destinationMatch[1];
					// Create a lowercase map of BANNER_IMAGE_MAP keys for case-insensitive lookup
					const lowerCaseMap = Object.keys(BANNER_IMAGE_MAP).reduce((acc, key) => {
						acc[key.toLowerCase()] = BANNER_IMAGE_MAP[key];
						return acc;
					}, {});
					// Try to find banner image for the destination
					const destinationBanner = lowerCaseMap[destination.toLowerCase()];
					if (destinationBanner) {
						return destinationBanner;
					}
				}
				
				// Check if a region was selected from search suggestions (for departments/cities)
				if (this.selectedRegionName) {
					// Create a lowercase map of BANNER_IMAGE_MAP keys for case-insensitive lookup
					const lowerCaseMap = Object.keys(BANNER_IMAGE_MAP).reduce((acc, key) => {
						acc[key.toLowerCase()] = BANNER_IMAGE_MAP[key];
						return acc;
					}, {});
					const regionBanner = lowerCaseMap[this.selectedRegionName.toLowerCase()];
					if (regionBanner) {
						return regionBanner;
					}
				}
				return BANNER_IMAGE_MAP[this.getGroupTitle] ||
				"https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/notre+selection_hortense.webp";
			},
			lodgingsCounter() {
				return this.filteredLodgings.length;
			},
		},
		methods: {
			monthlyMatch(pathname) {
				const m = pathname.match(/\/offres-exclusives-(janvier|fevrier|mars|avril|mai|juin|juillet|aout|septembre|octobre|novembre|decembre)/i);
				return m ? m[1].toLowerCase() : null;
			},
			fetchAllLodgings() {
				fetcher.get('/all_online_lodgings')
					.then((response) => {
					this.allLodgings = response.data;
					})
					.catch((error) => {
					console.error(error);
					});
			},
			async fetchAvailabilityData(lodgingIds, start_date, end_date) {
				try {

					const response = await fetcher.post('/lodgings/rooms_availability', {
						lodging_ids: lodgingIds,
						start_date: start_date,
						end_date: end_date
					});

					if (response.data && response.data.availabilities) {
						this.roomsCountAvailability = response.data.availabilities;
						console.log('Availability data fetched:', this.roomsCountAvailability);
					}
				} catch (error) {
					this.roomsCountAvailability = {}
					console.error('Error fetching availability data:', error);
				}
			},
			// New v2 methods
			toggleFilterSidebar() {
				this.showFilterSidebar = !this.showFilterSidebar;
				const navbar = document.getElementById('navbar');
				if (this.showFilterSidebar) {
					if (navbar) navbar.style.zIndex = '0';
					document.body.style.overflow = 'hidden';
				} else {
					if (navbar) navbar.style.zIndex = '100';
					document.body.style.overflow = '';
				}
			},
			
			// Existing methods (unchanged from original)
			setUser(){
				this.showModal = false;
			},
			toggleMap() {
				this.showMap = !this.showMap;
				if (this.showMap) {
				document.body.classList.add("no-scroll");
				} else {
				document.body.classList.remove("no-scroll");
				}
			},
			hideBigMap() {
			   this.showMap = false;
			},
			setAdults(value) {
				this.allValues.adults = value;
				this.setLocalStorageReservationState()
			},
			setChilds(value) {
				this.allValues.childs = value;
				this.setLocalStorageReservationState()
			},
			constructUrl(pageNumber) {
				let baseUrl = '/';
				if (window.location.pathname.includes('les-nouveautes-hortense')) {
					baseUrl = '/les-nouveautes-hortense';
				} else if (window.location.pathname.includes('ecolodge')) {
					baseUrl = '/ecolodge';
				} else if (window.location.pathname.includes('chalet')) {
					baseUrl = '/chalet';
				} else if (window.location.pathname.includes('maisons-de-charme')) {
					baseUrl = '/maisons-de-charme';
				} else {
					switch (this.type) {
						case 'hotel':
							baseUrl = '/hotel-de-charme';
							break;
						case 'appartment':
							baseUrl = '/appartement-de-vacances';
							break;
						case 'other':
							baseUrl = '/logement-insolite-de-luxe';
							break;
						case 'guest':
							baseUrl = '/chambres-dhotes-de-charme';
							break;
						case 'villa':
							baseUrl = '/villa-de-charme';
							break;
						case 'villa':
							baseUrl = '/les-nouveautes-hortense';
							break;
						case 'destinations':
							baseUrl = window.location.pathname;
							break;
						case 'collections':
							baseUrl = window.location.pathname;
							break;
						case 'weekends':
							baseUrl = window.location.pathname;
							break;
						default:
							baseUrl = window.location.pathname;
					}
				}
				if (window.location.pathname.startsWith('/destination/')) {
					baseUrl = window.location.pathname;
				}
				return this.search && this.search != '' ? `${baseUrl}?search=${this.search}&page=${pageNumber}` : `${baseUrl}?page=${pageNumber}`;
			},
			fetchLodgings(pageNumber) {
				if (this.cancelTokenSource) {
					console.log('Request Cancelled.')
					this.cancelTokenSource.cancel('Previous request canceled');
				}
				this.cancelTokenSource = axios.CancelToken.source();
				this.isLoadingLodgings = true; // Show skeleton loading
				let params = {};

				const urlParams = new URLSearchParams(window.location.search);
				const startDateParam = urlParams.get('start_date');
				const endDateParam = urlParams.get('end_date');
				const search = urlParams.get('search');
				if (search) {
					this.search = search;
					params.search = search;
				}

				if (startDateParam && endDateParam && startDateParam !== 'null' && endDateParam !== 'null') {
					params.start_date = startDateParam;
					params.end_date = endDateParam;
				}
				if (this.koediaFrom) {
					params.start_date = this.koediaFrom;
				}
				if (this.koediaTo) {
					params.end_date = this.koediaTo;
				}
				if (this.base) {
					params.base = this.base;
				}

				// Add adults and childs params from component state
				if (this.allValues.adults) {
					params.adults = this.allValues.adults;
				}
				
				if (this.allValues.childs) {
					params.childs = this.allValues.childs;
				}

				// Add inscription param if present in URL and on inspirations page
        const inspirationParam = urlParams.get('inspiration');
        if (inspirationParam && window.location.pathname === '/inspirations-voyage-hortense') {
          params.inspiration = inspirationParam;
        }


				this.page = pageNumber;
				this.page_number_count = pageNumber;
				const url = this.constructUrl(pageNumber);

				console.log('this.changedFilters', this.changedFilters)

				Object.keys(this.changedFilters).forEach(filter => {
					params[filter] = this.changedFilters[filter];
				});

				console.log("Sending API Request with Params:", params);
				params['include_map'] = true; // Always include map lodgings
				fetcher.get(url, {
						params,
						cancelToken: this.cancelTokenSource.token,
					})
					.then(response => {
						console.log('response.data', response.data)
						
						if (response.data.lodgings && response.data.map_lodgings) {
							this.filteredLodgings = response.data.lodgings;
							this.previous_lodging = response.data.map_lodgings;
							console.log('Updated map lodgings from JSON response:', this.previous_lodging.length);
						} else {
							// Fallback for old structure (direct array)
							this.filteredLodgings = response.data;
						}
						
						// Handle filter counts from Elasticsearch aggregations
						if (response.data.filter_counts) {
							this.$set(this, 'filterCounts', response.data.filter_counts);
							console.log('Updated filter counts:', this.filterCounts);
						} else {
							this.$set(this, 'filterCounts', {});
						}
						
						this.pagedNumber = response.headers['x-lodgings-count'] || this.pagedNumber;
						this.setPages();
						
						// Fetch availability data for the loaded lodgings
						const lodgingIds = (response.data.lodgings || response.data).map(l => l.id);
						this.fetchAvailabilityData(lodgingIds, params.start_date, params.end_date);
					})
					.catch(error => {
						if (axios.isCancel(error)) {
							console.log('Request was cancelled:', error.message);
						} else {
							console.error('Failed to fetch lodgings:', error);
						}
					})
					.finally(() => {
						this.isLoadingLodgings = false; // Hide skeleton loading
						// Recalculate positions after new content is loaded
						this.recalculateCachedPositions();
					});
			},
			handleMapStickyBehavior() {
				if (this.isPhone) return; // Only for desktop
				
				// Use cached positions to prevent layout shift feedback loops
				if (!this.cachedPositions.initialized) {
					this.initializeCachedPositions();
					return;
				}
				
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				const searchBannerBottom = this.cachedPositions.searchBannerBottom - 40;
				const promotionBannerTop = this.cachedPositions.promotionBannerTop;
				
				// Map should be sticky when scrolled past search banner but before promotion banner
				const shouldBeSticky = scrollTop > searchBannerBottom && scrollTop < (promotionBannerTop - window.innerHeight);
				
				// Check if promotional banner is coming into view
				const promotionBannerInView = scrollTop >= (promotionBannerTop - window.innerHeight);
				
				if (shouldBeSticky !== this.mapStickyActive) {
					this.mapStickyActive = shouldBeSticky;
					this.updateMapStickyClasses();
				}
				// Show footer with animation when promotional banner comes into view
				if (promotionBannerInView) {
					this.showFooterWithAnimation();
				}
			},
			updateMapStickyClasses() {
				if (this.isPhone) return; // Only for desktop
				
				const mapPanel = document.querySelector('.map-panel');
				const contentArea = document.querySelector('.content-area.with-map');
				const whatsappBtn = document.getElementById('whatsapp-button');
				
				if (!mapPanel || !contentArea) return;
				
				// Use CSS classes only, avoid direct style manipulation
				if (this.mapStickyActive) {
					mapPanel.classList.add('map-sticky-active');
					contentArea.classList.add('map-sticky-active');
					if (whatsappBtn) {
						whatsappBtn.classList.add('hidden');
					}
				} else {
					mapPanel.classList.remove('map-sticky-active');
					contentArea.classList.remove('map-sticky-active');
					if (whatsappBtn) {
						whatsappBtn.classList.remove('hidden');
					}
				}
			},
			initializeCachedPositions() {
				if (this.isPhone) return;
				
				const promotionBanner = document.querySelector('#promotion-lodge-banner');
				const searchBanner = document.querySelector('#search-bannerr');
				
				if (promotionBanner && searchBanner) {
					this.cachedPositions.searchBannerBottom = searchBanner.offsetTop + searchBanner.offsetHeight;
					this.cachedPositions.promotionBannerTop = promotionBanner.offsetTop;
					this.cachedPositions.initialized = true;
					
					console.log('Cached positions updated:', {
						searchBannerBottom: this.cachedPositions.searchBannerBottom,
						promotionBannerTop: this.cachedPositions.promotionBannerTop
					});
				}
			},
			recalculateCachedPositions() {
				// Force recalculation of cached positions
				this.cachedPositions.initialized = false;
				// Cancel previous timeout if exists
				if (this.cachedPositionsTimeout) {
					clearTimeout(this.cachedPositionsTimeout);
				}
				this.$nextTick(() => {
					this.cachedPositionsTimeout = setTimeout(() => {
						this.initializeCachedPositions();
						this.cachedPositionsTimeout = null;
					}, 100);
				});
			},
			showFooterWithAnimation() {
				// Find the footer element and show it with animation
				const footer = document.querySelector('footer, .footer, #footer');
				if (footer) {
					AOS.refresh();
				}
			},
			async setupScrollListener() {
				if (this.isPhone) return; // Only for desktop
				
				// Only setup if not already done
				if (this.scrollHandler) return;
				
				// Initialize positions before setting up scroll listener
				this.$nextTick(() => {
					// Wait for DOM to be fully rendered
					setTimeout(() => {
						this.initializeCachedPositions();
					}, 100);
				});
				
				// Create and store throttled scroll handler
				const throttledHandler = _.throttle(() => {
					this.handleMapStickyBehavior();
				}, 16); // ~60fps
				
				// Store both the original throttled function and a wrapper for removal
				this.scrollHandler = throttledHandler;
				window.addEventListener('scroll', this.scrollHandler, { passive: true });
			},
			cleanupScrollListener() {
				if (this.scrollHandler) {
					window.removeEventListener('scroll', this.scrollHandler, { passive: true });
					// Cancel any pending throttled calls
					if (this.scrollHandler.cancel) {
						this.scrollHandler.cancel();
					}
					this.scrollHandler = null;
				}
			},
			handleMobileFooterVisibility() {
				if (!this.isPhone) return; // Only for mobile
				
				const footer = document.getElementById('p-footer');
				if (!footer) return;
				
				const footerRect = footer.getBoundingClientRect();
				const windowHeight = window.innerHeight;
				
				// Check if footer is coming into view (with some buffer)
				const footerInView = footerRect.top <= windowHeight + 50;
				
				// Hide mobile sticky filters when footer is in view, show when out of view
				this.showMobileStickyFilters = !footerInView;
			},
		async setupMobileScrollListener() {
			if (!this.isPhone) return; // Only for mobile
			
			// Only setup if not already done
			if (this.mobileScrollHandler) return;
			
			// Create and store throttled scroll handler
			const throttledMobileHandler = _.throttle(() => {
				this.handleMobileFooterVisibility();
			}, 16); // ~60fps
			
			this.mobileScrollHandler = throttledMobileHandler;
			window.addEventListener('scroll', this.mobileScrollHandler, { passive: true });
		},
		cleanupMobileScrollListener() {
			if (this.mobileScrollHandler) {
				window.removeEventListener('scroll', this.mobileScrollHandler, { passive: true });
				// Cancel any pending throttled calls
				if (this.mobileScrollHandler.cancel) {
					this.mobileScrollHandler.cancel();
				}
				this.mobileScrollHandler = null;
			}
		},
			updateDates(dates) {
				if(dates && dates.length > 0) {
					this.koediaFrom = this.formatDate(dates[0]);
					this.koediaTo = this.formatDate(dates[1]);
					this.from = this.koediaFrom;
					this.to = this.koediaTo;
				}
				this.setLocalStorageReservationState();
			},
			setLocalStorageReservationState() {
				localStorage.setItem('reservationState', JSON.stringify({}));
				const state = {
					koediaFrom: this.koediaFrom,
					koediaTo: this.koediaTo,
					from: this.from,
					to: this.to,
					adults: this.allValues.adults,
					childs: this.allValues.childs,
				};
				localStorage.setItem('reservationState', JSON.stringify(state));
			},
			formatDate(date) {
				if (!date) return null;
				const dateBits = date.split("/");
				return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
			},
			updateFilteredLodgings(newLodgings) {
				if (newLodgings.data.lodgings && newLodgings.data.map_lodgings) {
					this.filteredLodgings = newLodgings.data.lodgings;
					this.lodgings = newLodgings.data.lodgings;
					this.previous_lodging = newLodgings.data.map_lodgings;
					console.log('Updated map lodgings from search with JSON response:', this.previous_lodging.length);
				} else {
					// Fallback for old structure (direct array)
					this.filteredLodgings = newLodgings.data;
					this.lodgings = newLodgings.data;
				}
				
				// Handle filter counts from search results
				if (newLodgings.data.filter_counts) {
					// Use Vue.set or reactive assignment to ensure reactivity
					this.$set(this, 'filterCounts', newLodgings.data.filter_counts);
					console.log('Updated filter counts from search:', this.filterCounts);
				}
				
				this.pagedNumber = newLodgings.headers['x-lodgings-count'];
				// Recalculate positions after search results are updated
				this.recalculateCachedPositions();
			},
			hideSmallMap(){
				this.showMapCard = !this.showMapCard;
				
				// Only remove Mapfind modals, not the permanent Maptest component
				const mapfinds = document.querySelectorAll('[id="map-find"]');
				mapfinds.forEach((map) => {
					// Only remove if it's actually a modal overlay, not part of the permanent map
					if (map.closest('.desktop-map-overlay') || map.closest('.mobile-map-modal')) {
						map.remove();
					}
				});

				// Don't remove all maps - this was interfering with the permanent Maptest
				// const maps = document.querySelectorAll('[id="map"]');
				// maps.forEach((map) => {
				// 	map.remove();
				// });
			},
			async fetchWishlist() {
				try {
					if (this.user) {
						const response = await fetcher.get('/wishlists.json');
						this.wishlistLodgings = response.data.lodgings;
					}
				} catch (e) {
					console.error(e);
				}
			},
			scrollToTop() {
				window.scroll({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			},
			setPages() {
				this.page = 1;
				this.pages = [];
				let numberOfPages = Math.ceil((this.pagedNumber ? this.pagedNumber : this.filteredLodgings.length) / this.perPage);
				for (let index = 1; index <= numberOfPages; index++) {
					this.pages.push(index);
				}
			},
			paginate(lodgs) {
				let page = this.page;
				let perPage = this.perPage;
				let from = (page * perPage) - perPage;
				let to = (page * perPage);
				return  lodgs.slice(from, to);
			},
			debouncedFetchLodgings: _.debounce(function () {
				this.fetchLodgings(1);
			}, 1000),
			buildMergedServices() {
				const servicesList = this.services || [];
				const serviceEntiersList = typeof this.serviceEntiers === 'string'
					? JSON.parse(this.serviceEntiers)
					: (this.serviceEntiers || []);

				const merged = [];
				const nameMap = {};

				servicesList.forEach(s => {
					if (s && s.name) {
						const key = s.name.toLowerCase().trim();
						nameMap[key] = {
							id: s.id,
							name: s.name,
							serviceEntierId: null
						};
						merged.push(nameMap[key]);
					}
				});

				serviceEntiersList.forEach(se => {
					if (se && se.name) {
						const key = se.name.toLowerCase().trim();
						if (nameMap[key]) {
							nameMap[key].serviceEntierId = se.id;
						} else {
							nameMap[key] = {
								id: null,
								name: se.name,
								serviceEntierId: se.id
							};
							merged.push(nameMap[key]);
						}
					}
				});

				this.servicesMount = merged;
			},
			setData(val, name) {
				if (!this.changedFilters) {
					this.changedFilters = {};
				}
				console.log('val', val)

				if (name === "services") {
					if (val && typeof val === 'object' && !Array.isArray(val)) {
						const { serviceIds, serviceEntierIds } = val;
						if (serviceIds && serviceIds.length > 0) {
							this.changedFilters.services = serviceIds;
						} else {
							delete this.changedFilters.services;
						}
						if (serviceEntierIds && serviceEntierIds.length > 0) {
							this.changedFilters.service_entiers = serviceEntierIds;
						} else {
							delete this.changedFilters.service_entiers;
						}
					} else if (Array.isArray(val)) {
						if (val.length > 0) {
							this.changedFilters.services = val;
						} else {
							delete this.changedFilters.services;
						}
					}
				} else if ((Array.isArray(val) && val.length === 0) || val === null || val === undefined || val === '' || val === false) {
					delete this.changedFilters[name];
				} else {
					if (name === 'eq_services') {
						this.changedFilters[name] = this.changedFilters[name] || [];
						if (!this.changedFilters[name].includes(val)) {
							this.changedFilters[name].push(val[0]);
						}
					} else if (name === 'eq_services_entiers') {
						this.changedFilters[name] = this.changedFilters[name] || [];
						if (!this.changedFilters[name].includes(val)) {
							this.changedFilters[name].push(val[0]);
						}
					} else {
						this.changedFilters[name] = val;
					}
				}
				this.debouncedFetchLodgings();
				console.log("Updated changedFilters:", this.changedFilters);
			},
			showFilters() {
				const filter = document.querySelector('#filter-lodging');
				if (filter.style.display === 'block') {
					this.showFilt = false;
					filter.style.display = 'none';
				} else {
					filter.style.display = 'block';
					this.showFilt = true;
				}
			},
			isUserConnected() {
				return this.user ? this.user : null;
			},
			sortByNote() {
				this.changedFilters.sort_by = 'score';
				this.changedFilters.sort_direction = this.asc ? 'asc' : 'desc';
				this.asc = !this.asc;
				this.fetchLodgings(1);
			},
			sortByTarif() {
				this.changedFilters.sort_by = 'price';
				this.changedFilters.sort_direction = this.tarifSort ? 'asc' : 'desc';
				this.tarifSort = !this.tarifSort;
				this.fetchLodgings(1);
			},
			selectCard(attr) {
				const cards = document.querySelectorAll('#cardProduct-big');
				const selectedCard = Array.from(cards).find(node => node.dataset.lodging === attr.toString());
				this.selectedCard = selectedCard;
				this.selectedMarker = attr;
				cards.forEach((el) => {
					if (el?.dataset?.marker !== selectedCard?.dataset?.marker) {
						el.style.display === 'none' ? (el.style.display = 'flex') : (el.style.display = 'none');
					}
				});
				this.selectedLodging = this.previous_lodging.find((lod) => {
					return lod.id === parseInt(attr);
				});
			},
			selectCardMap(attr){
				if(this.showMap){
					setTimeout(() => {this.showMap = false}, 10);
					setTimeout(() => {this.showMap = true}, 10);
				}
			},
			displayMap() {
				this.showMap = !this.showMap;
			},
			formatLodgings() {
				let hebergement = ' hébergement';
				if ((this.lodgingsCountBeforeFiltering && this.lodgingsCountBeforeFiltering > 0 ? this.lodgingsCountBeforeFiltering : this.lodgingsCounter) > 1) {
					hebergement += 's';
				}
				return (this.lodgingsCountBeforeFiltering && this.lodgingsCountBeforeFiltering > 0 ? this.lodgingsCountBeforeFiltering : this.lodgingsCounter) + hebergement;
			},
			formatLodgingsCount() {
				const count = this.pagedNumber ? this.pagedNumber : this.lodgingsCounter;
				const formattedCount = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
				return `${formattedCount} hébergement${formattedCount > 1 ? 's' : ''} encore disponible${formattedCount > 1 ? 's' : ''} à vos dates.`;
			},
			async loadSearchContent() {
				const path = window.location.pathname;
				try {
				const res = await fetcher.get(`/search_results_contents/show_by_page_type?page_type=${encodeURIComponent(path)}`);
				console.log('res', res)
				this.searchContent = res.data;

				this.$nextTick(() => {
					const el = this.$refs.contentBlock;
					if (el && el.scrollHeight > 300) {
					this.contentExceedsLimit = true;
					}
				});
				} catch (error) {
				console.error("Failed to load search content:", error);
				}
			},
			handleCardHover(event) {
				this.hoveredLodgingId = event.isHovered ? event.lodgingId : null;
			},
			handleFocusOnMap(data) {
				// Call the focusOnLodging method on the MapTest component
				if (this.$refs.mapTest) {
					this.$refs.mapTest.focusOnLodging(data.lodgingId);
				}
			},
			handleFetchAvailabilityData(data) {
				// Handle availability data fetch request from child component
				this.fetchAvailabilityData(data.lodgingIds, data.start_date, data.end_date);
			},
			handleWishlistUpdated(updatedWishlist) {
				// Update the parent's wishlist state when a child component updates it
				this.wishlistLodgings = updatedWishlist;
			},
			parseInitialFilteredLodgings() {
				// Parse initial filtered lodgings data from prop
				if (this.allFilteredLodgings && this.allFilteredLodgings !== "[]") {
					try {
						const parsed = JSON.parse(JSON.stringify(this.allFilteredLodgings));
						console.log('Initialized map with filtered lodgings:', parsed.length);
						return parsed;
					} catch (e) {
						console.error('Error parsing initial filtered lodgings:', e);
					}
				}
				
				// Fallback to regular lodgings if no filtered data available
				if (this.lodgings && this.lodgings.length > 0) {
					const parsedLodgings = this.lodgings.map((el) => {
						if (typeof el === 'string') {
							try {
								return JSON.parse(el);
							} catch (e) {
								return el;
							}
						}
						return el;
					});
					
					return parsedLodgings.filter(lodging =>
						lodging.latitude && lodging.longitude
					);
				}
				
				return [];
			},
			initializeMapData() {
				// Initialize map data on component creation
				this.previous_lodging = this.parseInitialFilteredLodgings();
				console.log('Map initialized with lodgings:', this.previous_lodging.length);
			}
		},
		mounted() {
			// Load search state from localStorage
			const reservationState = localStorage.getItem('reservationState');
			if (reservationState) {
				try {
					const state = JSON.parse(reservationState);
					if (state.search) {
						this.search = state.search;
					}
					if (state.koediaFrom) {
						this.koediaFrom = state.koediaFrom;
						this.from = state.from || state.koediaFrom;
					}
					if (state.koediaTo) {
						this.koediaTo = state.koediaTo;
						this.to = state.to || state.koediaTo;
					}
					if (state.adults) {
						this.allValues.adults = state.adults;
					}
					if (state.childs) {
						this.allValues.childs = state.childs;
					}
					if (state.base) {
						this.base = state.base;
					}
				} catch (e) {
					console.error('Error parsing reservationState from localStorage:', e);
				}
			}
			
			Promise.all([this.fetchWishlist(), this.fetchAllLodgings(), this.setupScrollListener(), this.setupMobileScrollListener(), this.loadSearchContent(), this.fetchLodgings(1)])
			
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'view_item_list',
				item_list_name: this.getGroupTitle,
				item_list_id: 'lodgings'
			});
			
			const whatsappBtn = document.getElementById('whatsapp-button');
			if (whatsappBtn) {
				whatsappBtn.style.top = '80%';
				whatsappBtn.style.right = '-7px';
			}
			// set width for img in whatsapp-button id
			const whatsappImg = document.querySelector('#whatsapp-button img');
			if (whatsappImg) {
				whatsappImg.style.width = '60px';
			}
			// Initialize AOS only once
			if (!window._aosInitialized) {
				AOS.init();
				window._aosInitialized = true;
			} else {
				AOS.refresh();
			}
			const el = this.$refs.contentBlock;
			if (el && !el.querySelector('.scoped-html-inner')) {
				const inner = document.createElement('div');
				inner.className = 'scoped-html-inner';
				inner.innerHTML = el.innerHTML;
				el.innerHTML = '';
				el.appendChild(inner);
			}
		},

		beforeDestroy() {
			// Cleanup all scroll listeners properly
			this.cleanupScrollListener();
			this.cleanupMobileScrollListener();
			document.body.style.overflow = '';
			
			// Clear any pending timeouts
			if (this.cachedPositionsTimeout) {
				clearTimeout(this.cachedPositionsTimeout);
				this.cachedPositionsTimeout = null;
			}
		},
		created() {
			this.buildMergedServices();
			
			// Initialize map data with current lodgings on first load
			this.initializeMapData();
		},
	};
</script>

<style lang="scss" scoped>
/* V2 Specific Styles */
.main-content-wrapper {
	position: relative;
	display: flex;
	flex-direction: column;
}

.content-with-map-wrapper {
	display: flex;
	flex-direction: column;
	
	@media (min-width: 769px) {
		flex-direction: row;
		min-height: 100vh;
		overflow: visible;
		position: relative;
	}
}

.content-area {
	flex: 1;
	
	&.with-map {
		@media (min-width: 769px) {
			width: 63%;
			padding-right: 20px;
			min-height: 100vh;
			position: relative;
			z-index: 1;
		}
	}
	
	&.map-sticky-active {
		@media (min-width: 769px) {
			margin-right: 37%;
			transition: smooth margin-right 0.3s ease;
		}

		&.lodgings-grid {
			margin-top: 20%;
		}
	}
}

/* Filter Sidebar Styles */
.filter-sidebar {
	position: fixed;
	top: 0;
	left: -400px;
	width: 400px;
	height: 100vh;
	background: white;
	box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
	z-index: 2147483646; /* Always above page sections, including footer */
	transition: left 0.3s ease;
	overflow-y: auto;
	padding-bottom: 2%;
	&.filter-sidebar-open {
		left: 0;
	}

	/* Custom scrollbar styling for filter sidebar */
	&::-webkit-scrollbar {
		width: 4px; /* Thinner scrollbar as requested */
	}
	&::-webkit-scrollbar-track {
		border-radius: 2px;
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 2px;
	}
}

.filter-sidebar-content {
	padding: 20px;
}

.filter-sidebar-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 15px;
	border-bottom: 1px solid #eee;
}

.close-filter-btn {
	background: none;
	border: none;
	font-size: 24px;
	cursor: pointer;
	color: #666;
	
	&:hover {
		color: #000;
	}
}

.filter-sidebar-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.3);
	z-index: 2147483645; /* Just below the filter sidebar */
}

.filter-toggle-btn {
	background: white;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 8px 16px;
	cursor: pointer;
	transition: all 0.2s ease;
	
	&:hover {
		background: #f8f9fa;
		border-color: #3B6152;
	}
}

/* Map Panel Styles */
.map-panel {
	@media (min-width: 769px) {
		width: calc(100% - min(1112px, 63%));
		position: sticky;
		top: 0;
		height: 100vh;
		border-left: 1px solid #eee;
		z-index: 100;
		overflow: hidden;
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		align-self: flex-start; /* Ensures sticky positioning works correctly */
		transition: all 0.3s ease;
	}
	
	&.map-sticky-active {
		@media (min-width: 769px) {
			position: fixed;
			top: 40px;
			right: 0;
			width: 37%;
			height: 100vh;
			z-index: 1000;
			box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
		}
	}
}

.map-panel-header {
	padding: 20px;
	border-bottom: 1px solid #eee;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: white;
	position: sticky;
	top: 0;
	z-index: 101;
}

.lodging-count {
	font-size: 14px;
	color: #666;
}

.map-container {
	height: 100vh;
	position: relative;
	overflow: hidden;
	flex: 1;
	/* Custom scrollbar styling for map container if needed */
	&::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}
	&::-webkit-scrollbar-track {
		border-radius: 3px;
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 3px;
	}
}

/* Lodgings Grid Styles */
.lodgings-grid {
	&.loading {
		opacity: 0.7;
	}
}

.skeleton-container {
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
	
	@media (min-width: 769px) {
		grid-template-columns: repeat(2, 1fr);
	}
}

.lodgings-list {
	display: flex;
	flex-direction: column;
}

.lodgings-grid-container {
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
	
	@media (min-width: 769px) {
		grid-template-columns: repeat(2, 1fr);
		grid-auto-rows: min-content; /* This ensures all grid items have equal height */
	}
}

.lodging-item {
	width: 100%;
	display: flex; /* Make the container flex */
	flex-direction: column; /* Stack content vertically */
	
	@media (min-width: 769px) {
		height: 100%; /* Take full height of grid cell */
	}
	
	/* Ensure the card component takes full height */
	& > * {
		@media (min-width: 769px) {
			flex: 1; /* Allow the card to grow and fill available space */
			display: flex;
			flex-direction: column;
		}
	}
}

/* Target the actual CardProductbigV2 component structure */
.lodging-item ::v-deep #cardProduct-big-v2 {
	@media (min-width: 769px) {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
}

/* Remove spacing between image and content */
.lodging-item ::v-deep #cardProduct-big-v2 .hub-img-zoom {
	@media (min-width: 769px) {
		flex-shrink: 0; /* Image doesn't shrink */
		margin-bottom: 0; /* Remove bottom margin */
	}
}

/* Ensure card-hub-info flows immediately after image with no spacing */
.lodging-item ::v-deep #cardProduct-big-v2 .card-hub-info {
	@media (min-width: 769px) {
		flex: 1;
		padding-top: 15px; /* Remove top padding */
		margin-top: 0; /* Remove top margin */
	}
}

/* Existing styles from original file */
.page-item{
	border-color: black;
	button{
		display: inline-block;
		color: black;
	}
}
.active-item{
	color: green;
	border-color: black;
	border-style: solid;
}
.cta{
	margin: 0px auto;
	display: inline
}

#search-bannerr.sticky {
	position: fixed;
	width: 75% !important;
	z-index: 1000;
	background: transparent;
}

.lodge-page-main {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 0;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
	.custom-index {
		margin-top: 13vh !important;
	}
	#lodging-all .desti-header {
		margin-bottom: 0.5rem !important;
	}
	.lodge-title{
		font-size: 30px !important;
	}
	.lodge-description{
		font-size: 18px !important;
	}
	.btn-filters {
		margin-bottom: 1rem !important;
		margin-top: 0.5rem !important;
	}
	
	.content-area.with-map {
		width: 100% !important;
		padding-right: 0 !important;
		height: auto !important;
		overflow-y: visible !important;
	}
	
	.content-with-map-wrapper {
		height: auto !important;
		overflow: visible !important;
	}
	
	.map-panel {
		display: none !important;
	}
}

.full-page-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 9999;
	background-color: rgba(0, 0, 0, 0.8);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
}

.mt-page {
	margin-top: -7vh !important;
	z-index: 1;
}

.modal-header {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	padding: 10px 20px;
	background-color: rgba(0, 0, 0, 0.9);
	z-index: 1001;
}

.close-btn {
	font-size: 30px;
	color: white;
	background: transparent;
	border: none;
	cursor: pointer;
}

@media only screen and (max-width: 480px) {
	.close-btn {
		font-size: 24px;
		padding: 5px;
		position: fixed;
		top: 10px;
		right: 10px;
		z-index: 1002;
	}
	#map-test {
		flex: 1;
		width: 100%;
		height: 100%;
	}

	.mapboxgl-canvas {
		width: 100% !important;
		height: 85% !important;
	}
	.mt-page {
		margin-top: 17vh !important;
	}
}

.no-scroll {
	overflow: hidden;
	height: 100vh;
}

.filter-layer-active {
	position: relative;
	z-index: 2147483644;
}

.hortense-cta-button-desktop {
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	background-color: #3B6152;
	color: white;
	padding: 12px 20px;
	border: none;
	font-family: $Raleway;
	font-weight: 500;
	font-size: 13px;
	cursor: pointer;
	z-index: 10;
}

.hortense-cta-button-on-image {
	position: absolute;
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
	background-color: #3B6152;
	color: white;
	padding: 8px 16px;
	border: none;
	font-size: 13px;
	font-family: $Raleway;
	font-weight: 500;
	cursor: pointer;
}

.hortense-cta-button-on-image-two {
	position: absolute;
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
	background-color: #3B6152;
	color: white;
	padding: 8px 16px;
	border: none;
	font-size: 13px;
	font-family: $Raleway;
	font-weight: 500;
	cursor: pointer;
}

.search-page-html-wrapper .collapsed {
	max-height: 300px;
	overflow: hidden;
	position: relative;
	mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
	-webkit-mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
}

.expand-toggle {
	text-decoration: underline;
	cursor: pointer;
	color: #000;
	font-weight: 500;
	font-family: $Raleway;
}

.scoped-html .scoped-html-inner {
	all: initial;
	font-family: sans-serif;
	color: #333;
}

.scoped-html .scoped-html-inner p {
	margin: 0 0 1em;
}

.scoped-html .scoped-html-inner h1,
.scoped-html .scoped-html-inner h2 {
	color: #222;
}


:deep(.seo-text h2) {
  font-family: 'Merriweather', Georgia, 'Times New Roman', serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.35;
  margin: 0 0 0.6em;
  color: #222;
}

:deep(.seo-text h3) {
  font-family: 'Raleway', Arial, sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.4;
  margin: 1.2em 0 0.5em;
  color: #222;
}

:deep(.seo-text p) {
  font-family: 'Raleway', Arial, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.7;
  margin: 0 0 1em;
  color: #333;
}

@media (max-width: 767px) {
  :deep(.seo-text h2) { font-size: 24px; }
}



.container-index {
	width: 95%;
}


#promotion-lodge-banner {
	justify-content: center;
}

/* Performance optimizations */
.map-panel {
	will-change: transform, position; /* Hint browser for GPU acceleration */
}

.content-area.with-map {
	will-change: margin-right; /* Hint browser for GPU acceleration */
}

/* Reduce layout shifts */
.map-sticky-active {
	transform: translateZ(0); /* Force GPU layer */
}

/* Smooth transitions for all sticky elements */
// .map-panel,
// .content-area.with-map {
// 	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
// }

// h2 {
//   font-family: "Merriweather" !important;
//   font-weight: 400 !important;
//   font-size: 26px !important;
// }

// h3 {
//   font-family: "Raleway" !important;
//   font-weight: 700 !important;
//   font-size: 15px !important;
// }

// p {
//   font-family: "Raleway" !important;
//   font-weight: 400 !important;
//   font-size: 15px !important;
// }

// @media (max-width: 767px) {
//   h2 { font-size: 24px !important; }
//   h3 { font-size: 15px !important; }
//   p  { font-size: 15px !important; }
// }
</style>


